<div class="dashboard-container" appFluidContainer [fluidUntil]="'lg'">
  <div class="row dashboard-overview-messages">
    <div class="col-6"><img src="../../../assets/icon/car-parking.svg"> <span class="all-scans-message"
        i18n="dashboard|@@all_scans">Tous vos scans</span></div>
    <div class="col-6 not-read-message" *ngIf="!isSearching && unreadCount" i18n="dashboard|@@scans_not_read">Vous avez
      {{unreadCount}}
      tcheks non-lus.</div>
    <!-- <div class="col-6 not-read-message" *ngIf="count && !isSearching && numberTchek" i18n="dashboard|@@scans_count">Vous
      avez réalisé {{numberTchek}} tcheks.</div> -->
    <div class="col-6 not-read-message" *ngIf="isSearching && count" i18n="dashboard|@@search_results">Résultat de la
      recherche :
      {{count}}.</div>
  </div>

  <div class="row dashboard-inputs">
    <div class="col-12">
      <app-finder (searchResults)="handleSearchResults($event)" (loading)="handleSearchLoading($event)"
        (searchTriggered)="undefined"></app-finder>
    </div>
  </div>

  <div class="row dashboard-table">
    <div class="col-12">
      <app-tchek-list></app-tchek-list>
      <div *ngIf="resultTchek">
        <div class="center" *ngIf="!onSearch">
          <button type="button" class="btn btn-lg secondary" (click)="addTcheks()">
            <span class="text-span" i18n="dashboard|@@show_more">Voir plus</span>
          </button>
        </div>
        <div class="center" *ngIf="onSearch">
          <img class="spinner" src="../../assets/images/spinner.gif" />
          <button type="button" class="btn btn-lg secondary" style="width: 45px;">
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row dashboard-stats-blocks" *ngIf="isSuperAdmin">
    <div class="col-12 col-lg-6">
      <div appFluidContainer [fluidUntil]="'lg'">
        <app-reports-stats></app-reports-stats>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div appFluidContainer [fluidUntil]="'lg'">
        <app-reports-monitor></app-reports-monitor>
      </div>
    </div>
  </div>

  <div class="row dashboard-add-stats" *ngIf="isSuperAdmin">
    <div class="col-12">
      <app-add-stats-modal></app-add-stats-modal>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.html